import {
  ListItemButton,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material';
import { useState } from 'react';

import { StatusIcon } from '@/components/DataDisplay/StatusIcon';
import {
  ActionButton,
  ListActionItemContainer,
} from '@/components/Form/ActionList/ActionList.styled';
import { useCheckPersonalDetails } from '@/components/PageForm/PersonalDetails/Review/hooks/useCheckPersonalDetails';

import { useDrawerOpenTracker } from '@/context';

import { useTranslate } from '@/hooks/useTranslate';

import { DocumentStatus } from '@/types/document';

import { getDataTestId } from '@/utils/browser';

import { ReviewPersonalInfoDrawer } from './components/Review/ReviewPersonalInfoDrawer';
import { UpdatePersonalInfoDrawer } from './components/UpdatePersonalInfo/UpdatePersonalInfoDrawer';

export function PersonalDetails() {
  const { t } = useTranslate();
  const theme = useTheme();
  const [openUpdateDrawer, setOpenUpdateDrawer] = useState<boolean>(false);
  const [isShowingReviewPersonalInfo, setIsShowingReviewPersonalInfo] =
    useState<boolean>(false);

  useDrawerOpenTracker(openUpdateDrawer || isShowingReviewPersonalInfo);

  const { user, isUserInfoComplete } = useCheckPersonalDetails();

  if (!user) {
    return null;
  }

  const onCloseDrawer = () => {
    setOpenUpdateDrawer(false);
  };

  const onOpenUpdateDrawer = () => {
    setOpenUpdateDrawer(true);
  };

  const onOpenReviewPersonalInfo = () => {
    setIsShowingReviewPersonalInfo(true);
  };

  const onCloseReviewPersonalInfo = () => {
    setIsShowingReviewPersonalInfo(false);
  };

  return (
    <>
      <ListActionItemContainer
        {...getDataTestId(`list-action-item-personalDetails`)}
      >
        <ListItemText
          primary={
            <Typography variant="h5">
              {t('moreInfo.form.personalDetails.title')}
            </Typography>
          }
          secondary={
            <Typography
              variant="caption"
              color={
                isUserInfoComplete && user?.clientReviewed
                  ? theme.palette.status[DocumentStatus.Approved].text
                  : theme.palette.text.secondary
              }
            >
              {isUserInfoComplete && user?.clientReviewed
                ? t('moreInfo.form.personalDetails.status.reviewed')
                : t('moreInfo.form.personalDetails.description')}
            </Typography>
          }
        />
        <ListItemButton>
          <ActionButton
            {...getDataTestId(`review-personal-details-button`)}
            onClick={onOpenReviewPersonalInfo}
            disabled={isUserInfoComplete && user?.clientReviewed}
          >
            {!isUserInfoComplete || !user?.clientReviewed ? (
              <StatusIcon value="" iconName="arrow-right" />
            ) : (
              <StatusIcon value={DocumentStatus.Approved} />
            )}
          </ActionButton>
        </ListItemButton>
      </ListActionItemContainer>
      {openUpdateDrawer && (
        <UpdatePersonalInfoDrawer open onClose={onCloseDrawer} />
      )}
      {isShowingReviewPersonalInfo && (
        <ReviewPersonalInfoDrawer
          open
          isUserInfoComplete={isUserInfoComplete}
          user={user}
          onClose={onCloseReviewPersonalInfo}
          onUpdate={onOpenUpdateDrawer}
        />
      )}
    </>
  );
}
